import { useState } from "react";
import { ArrowDownRight, CheckCircle2, XCircle, Paperclip, Eye } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { TransactionDetail } from "./TransactionDetail";
import { API, money } from "../lib/api";

const statusLabel = { approved: "Disetujui", rejected: "Ditolak", pending: "Menunggu" };

export const TransactionTable = ({ rows, user, refresh, decisions }) => {
  const [selected, setSelected] = useState(null);
  const approve = async (id) => {
    try { await axios.patch(`${API}/transactions/${id}`, { status: "approved" }); toast.success("Pengeluaran disetujui"); refresh(); }
    catch (err) { toast.error(err.response?.data?.detail || "Gagal memproses"); }
  };
  const current = selected && rows.find(t => t.id === selected.id);
  return <div className="table-wrap"><table><thead><tr><th>TRANSAKSI</th><th>KATEGORI</th><th>TANGGAL</th><th>NOMINAL</th><th>STATUS</th><th>{decisions ? "AKSI" : ""}</th></tr></thead><tbody>
    {rows.map(t => <tr key={t.id} className="clickable" data-testid={`trx-row-${t.id}`} onClick={() => setSelected({ id: t.id, mode: "view" })}>
      <td><div className="transaction-name"><span className="type-icon expense"><ArrowDownRight size={15} /></span><div><strong>{t.sub_category || t.description}</strong>{t.attachments && <small className="attach-count"><Paperclip size={11} /> {Object.keys(t.attachments).length} lampiran</small>}</div></div></td>
      <td><strong>{t.category}</strong></td>
      <td>{new Date(t.date).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" })}</td>
      <td className="amount">{money(t.amount)}</td>
      <td><span className={`status ${t.status}`}>{statusLabel[t.status]}</span>{t.status === "rejected" && t.note && <small className="reject-inline" data-testid={`reject-note-${t.id}`}>{t.note}</small>}</td>
      <td onClick={e => e.stopPropagation()}>{decisions ? <div className="row-actions">
        <button data-testid={`approve-${t.id}`} title="Setujui" onClick={() => approve(t.id)}><CheckCircle2 size={16} /></button>
        <button data-testid={`reject-${t.id}`} title="Tolak dengan alasan" onClick={() => setSelected({ id: t.id, mode: "reject" })}><XCircle size={16} /></button>
        <button data-testid={`view-${t.id}`} title="Lihat lampiran" onClick={() => setSelected({ id: t.id, mode: "view" })}><Eye size={16} /></button>
      </div> : <button className="view-btn" data-testid={`view-${t.id}`} onClick={() => setSelected({ id: t.id, mode: "view" })}>Detail</button>}</td>
    </tr>)}
  </tbody></table>
  {current && <TransactionDetail trx={current} user={user} mode={selected.mode} onClose={() => setSelected(null)} onChanged={refresh} />}
  </div>;
};
